import React from 'react';
import './Footer.css';
import contactData from '../data/contact.json';
import { useContent } from '../contexts/ContentContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { getSection } = useContent();
  const data = getSection<typeof contactData>('contact', contactData);
  const { contact } = data;

  const quickLinks = [
    { label: 'Home', href: '#home' },
    { label: 'Featured', href: '#featured' },
    { label: 'Events', href: '#events' },
    { label: 'Workshops', href: '#workshops' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Team', href: '#team' }
  ];

  const normalizeUrl = (url: string) => {
    if (!url) {
      return '#';
    }
    const trimmed = url.trim();
    if (trimmed.startsWith('https://https://')) {
      return trimmed.replace('https://https://', 'https://');
    }
    if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('#')) {
      return trimmed;
    }
    return `https://${trimmed}`;
  };

  const socialIconClass = (icon: string) => {
    const map: Record<string, string> = {
      instagram: 'fab fa-instagram',
      linkedin: 'fab fa-linkedin-in',
      github: 'fab fa-github',
      twitter: 'fab fa-x-twitter',
      facebook: 'fab fa-facebook-f'
    };
    return map[icon] || 'fas fa-link';
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/assets/logos/club-logo.png" alt="ASIMO Technical Club Logo" />
              <div>
                <h3>ASIMO</h3>
                <p className="footer-brand-subtitle">Technical Club</p>
              </div>
            </div>
            <p className="footer-description">{contact.description}</p>

            <div className="footer-social" aria-label="Social links">
              {contact.socialLinks.map((social) => (
                <a
                  key={social.platform}
                  href={normalizeUrl(social.url)}
                  className="social-link"
                  aria-label={social.platform}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={socialIconClass(social.icon)}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="footer-nav">
            <h4>Quick Navigation</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact</h4>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>{contact.address}</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-globe"></i>
                <a href={normalizeUrl(contact.college.website)} target="_blank" rel="noopener noreferrer">
                  {contact.college.shortName}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} ASIMO Technical Club, GEC Samastipur. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#about">About</a>
              <a href="#contact">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;